import { MutableRefObject } from 'react';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import { renderComponentToElement } from 'components/DraggableContainer';
import { getDragImage } from 'components/DraggableContainer/utils';

export const updateExternalDragIcon = (
  iconRef: MutableRefObject<HTMLElement | null>,
  tooltipRef: MutableRefObject<HTMLElement | null>,
  draggedNodes: unknown[],
  isValid: boolean,
  isValidStateRef: MutableRefObject<boolean>,
) => {
  if (!iconRef?.current || isValidStateRef.current === isValid) {
    return;
  }

  if (isValid) {
    const dragImage = getDragImage(true, draggedNodes);
    iconRef.current.replaceChildren(dragImage);
    if (tooltipRef?.current) {
      tooltipRef.current.style.visibility = 'hidden';
    }
  } else {
    const dragImage = renderComponentToElement(RMSvgIcon, {
      name: 'DragError',
      height: '2.25rem',
      width: '2.25rem',
    });
    iconRef.current.replaceChildren(dragImage);
    if (tooltipRef?.current) {
      tooltipRef.current.style.visibility = 'visible';
      tooltipRef.current.innerText = "Can't add screen";
    }
  }
  isValidStateRef.current = isValid;
};
